import { createFileRoute } from "@tanstack/react-router";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";
import { RenataConfig } from "@/components/renata/RenataConfig";
import { RenataPageChrome } from "@/components/renata/RenataPageChrome";

export const Route = createFileRoute("/app/renata/config")({
  component: RenataConfigPage,
  head: () => ({ meta: [{ title: "Renata — Configuración" }] }),
});

function RenataConfigPage() {
  const tenantId = useWorkspaceTenantId();
  if (!tenantId) return null;

  return (
    <div className="flex-1 overflow-y-auto p-4 md:p-6">
      <div className="max-w-lg space-y-4">
        <RenataPageChrome
          screenId="config"
          title="Configuración"
          subtitle="Personalizá el tono de Renata. La personalidad base no cambia — solo la forma de expresarse."
          showBack
          breadcrumb={["Ajustes", "Configuración"]}
        />
        <RenataConfig tenantId={tenantId} />
      </div>
    </div>
  );
}
